import { render, staticRenderFns } from "./UserImageUploader.vue?vue&type=template&id=083136c6&scoped=true"
import script from "./UserImageUploader.vue?vue&type=script&lang=js"
export * from "./UserImageUploader.vue?vue&type=script&lang=js"
import style0 from "./UserImageUploader.vue?vue&type=style&index=0&id=083136c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083136c6",
  null
  
)

export default component.exports